import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Accounts } from '@/pages/accounts';
import { commonSearchSchema } from '@/routes/-shared/commonSearchSchema';
import { RoleGuard } from '@/components/molecules/role-guard';
import { usePermissions } from '@/hooks/use-permissions';
import z from '@/lib/zod';
import {
  optionalSearchBoolean,
  optionalSearchString,
} from '@/lib/zod-search-params';
import { amountSearchParams } from '@/lib/filters/amount-search-params';

export const accountsSearchSchema = commonSearchSchema.extend({
  showArchived: z.boolean().nullish(),
  subTab: z.string().nullish(),
  // Cash movements filters
  accountId: optionalSearchString(),
  categoryIds: optionalSearchString(),
  type: optionalSearchString(),
  dateFrom: optionalSearchString(),
  dateTo: optionalSearchString(),
  isReconciled: z.boolean().nullish(),
  isUncategorized: z.boolean().nullish(),
  // Pannello Filtri (stessi nomi dell'API): senza dichiararli zod li
  // strippa dall'URL e il filtro sparirebbe al primo refresh.
  ...amountSearchParams,
  currency: optionalSearchString(),
  statuses: optionalSearchString(),
  importSources: optionalSearchString(),
  hasNote: optionalSearchBoolean(),
  openReconciliation: z.boolean().nullish(),
});

export type AccountsSearchSchema = z.infer<typeof accountsSearchSchema>;

export const Route = createFileRoute('/protected/_layout/accounts/_layout')({
  validateSearch: accountsSearchSchema,
  component: AccountsLayout,
});

function AccountsLayout() {
  const { canAccessAccounts, isLoading } = usePermissions();

  return (
    <RoleGuard hasAccess={canAccessAccounts} isLoading={isLoading}>
      <Accounts />
      <Outlet />
    </RoleGuard>
  );
}
